import { render, staticRenderFns } from "./SelectCharacteristics.vue?vue&type=template&id=48f7c21c&scoped=true"
import script from "./SelectCharacteristics.vue?vue&type=script&lang=js"
export * from "./SelectCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./SelectCharacteristics.vue?vue&type=style&index=0&id=48f7c21c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7c21c",
  null
  
)

export default component.exports